import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ActionReport from "../../components/actionReport/actionReport";
import { IUserReport } from "../../services/types/users.types";
import { TTherapistQuestionReport } from "../../services/types/user.types";
import MainContentLayout from "../../components/mainContentLayout/mainContentLayout";
import { Category } from "../../types/types";

function mapReportToUserReport(report: TTherapistQuestionReport): IUserReport {
  return {
    AvailabilityHours: null,
    AppointmentsProgramsNum: null,
    TotalReports: 0,
    Recommends: null,
    RoleName: null,
    Users: {
      Account: null,
      Address: "",
      CityId: null,
      City: null,
      Birth: report.UserBirth ?? "",
      CompanyId: 0,
      DateRegister: "",
      Email: null,
      FakeCompanyId: null,
      FirstName: report.UserFirstName,
      GenderId: null,
      Id: report.UserId,
      FullName: null,
      Guid: report.UsersGuid,
      LastName: report.UserLastName,
      Passport: "",
      Phone: report.UserPhone ?? "",
      PlanId: 0,
      RoleId: 1,
      Roles: null,
      StatusId: 1,
      TherapistSpecializations: [],
    },
  };
}

function ActionReportPage() {
  const navigate = useNavigate();
  const location = useLocation();

  const report = location.state?.report as TTherapistQuestionReport | undefined;

  const handleClose = () => {
    navigate(-1);
  };

  if (!report) {
    handleClose();
    return null;
  }

  const user = mapReportToUserReport(report);

  return (
    <MainContentLayout activeCategory={Category.Main} changeCategory={() => {}}>
      <ActionReport
        user={user}
        onClose={handleClose}
        initialQuestionnaireId={report.QuestionnaireId}
        initialQuestionnaireCompaniesId={report.QuestionnaireCompaniesId}
        initialCycle={report.Cycle}
        initialDefaultName={report.QuestionnaireName}
        initialQuestionnaireCompaniesScoreUsersId={report.QuestionnaireCompaniesScoreUsersId}
        initialTherapistsGuid={report.TherapistsGuid}
      />
    </MainContentLayout>
  );
}

export default ActionReportPage;
